import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  GetUserCommand,
} from '@aws-sdk/client-cognito-identity-provider'
import config from '../../../config'
import LogRocket from 'logrocket'

import AppConfig from '../../../config'

const client = new CognitoIdentityProviderClient({ region: AppConfig.aws.region })

const login = createAsyncThunk('auth/login', async ({ username, password }) => {
  const params = {
    AuthFlow: 'USER_PASSWORD_AUTH',
    ClientId: AppConfig.aws.cognito.clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  }

  // Get tokens by authenticating the user
  const authResponse = await client.send(new InitiateAuthCommand(params))

  // Check if the authentication was successful and accessToken is available
  if (authResponse?.AuthenticationResult?.AccessToken) {
    const userParams = {
      AccessToken: authResponse.AuthenticationResult.AccessToken,
    }

    // Get the user using the GetUserCommand and the access token
    const userResponse = await client.send(new GetUserCommand(userParams))

    if (config.logRocket.appId) LogRocket.identify(username)

    // Combine the tokens and user attributes into a single object for the fulfilled action payload
    return {
      tokens: authResponse.AuthenticationResult,
      user: userResponse.UserAttributes.reduce((acc, attr) => {
        acc[attr.Name] = attr.Value
        return acc
      }, {}),
    }
  } else {
    throw new Error('Authentication failed')
  }
})

export default login
